import React from "react";
import LegalDocumentView from "../components/legal/LegalDocumentView";
import { ConsentPurpose } from "../features/members/enums/ConsentPurpose";
import { getLegalDocument } from "../features/members/legal-documents";

interface MemberLegalDocumentPageProps {
  purpose: ConsentPurpose;
}

/**
 * Public, shareable page for a member-facing legal document. An instructor sends members the
 * link (e.g. /legal/terms) so they can read what they consent to without logging in.
 */
const MemberLegalDocumentPage: React.FC<MemberLegalDocumentPageProps> = ({
  purpose,
}) => {
  const document = getLegalDocument(purpose);

  if (!document) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-8">
        <p className="text-grey-30 dark:text-grey-70">Document not found.</p>
      </div>
    );
  }

  return (
    <div>
      <LegalDocumentView document={document} />
      <p className="max-w-3xl mx-auto px-4 pb-8 text-xs text-grey-50 dark:text-grey-70">
        Provided through TimePlanned by your instructor.
      </p>
    </div>
  );
};

export default MemberLegalDocumentPage;
